export const COLLECTINFOVIEW = "collect information";
export const SUGGESTAPOSTVIEW = "suggest a post view";
export const SUCCESSVIEW = "succesful submission";

export const MAINTEXT = "Main text";
export const ADDITIONALINFO = "Additional information text";
